export class IvrAssignmentUserTask {
    ivrAssignmentUserTaskID: number;
    ivrAssignmentDetail: any;        
	ivrAssignmentDetailID: number;
}

